<template>
  <div>
    <BaseTable
      :items="list"
      :headers="tableHeaders"
      :loading="loading"
      :pagination="paginationConfig"
      :idPrefix="idPrefix"
      clickable
      @rowClicked="onClickingMenu"
    >
      <!-- Custom skeleton slot -->
      <template #skeleton>
        <td class="p-4">
          <div class="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div class="h-4 bg-gray-200 rounded w-1/2"></div>
        </td>
        <td class="p-4">
          <div class="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div class="h-4 bg-gray-200 rounded w-1/2"></div>
        </td>
        <td class="p-4 text-center flex space-x-4">
          <div class="h-9 bg-gray-200 rounded-full w-9 shadow"></div>
          <div class="h-9 bg-gray-200 w-20 rounded-sm shadow"></div>
          <div class="h-9 bg-gray-200 w-20 rounded-sm shadow"></div>
        </td>
      </template>

      <!-- Custom item slot -->
      <template #item="{ item }">
        <td class="p-4 text-sm text-gray-900">
          <div>
            {{ item?.id }}
          </div>
        </td>
        <td class="p-4 text-sm text-gray-900">
          <div>
            {{ item?.attributes?.label }}
          </div>
        </td>
        <td class="p-4 text-sm text-gray-500">
          <div class="flex gap-3 items-center">
            <button
              :id="`${idPrefix}
              opendeletemenumodal${item?.id}`"
              @click.stop="openDeleteMenu(item?.id)"
              class="text-red-600 hover:text-white bg-red-50 hover:bg-red-600 rounded-full transition-colors flex items-center justify-center w-9 h-9 shadow-md mx-1 border-none"
              :title="translate('Delete')"
            >
              <i class="far fa-trash-alt"></i>
            </button>
            <BaseButton
              :id="`${idPrefix}hardreset${item?.id}`"
              label="Hard Reset"
              size="sm"
              variant="danger"
              @click.stop="hardReset(item?.id)"
            />
            <BaseButton
              :id="`${idPrefix}syncpos${item?.id}`"
              label="Sync POS"
              size="sm"
              variant="primary"
              @click.stop="syncPOS(item?.id)"
            />
          </div>
        </td>
      </template>

      <!-- Empty state slot -->
      <template #empty> No menus found </template>
    </BaseTable>
  </div>
</template>

<script>
import { translations } from '@/mixins';
import BaseTable from '@/components/BaseTable.vue';
import BaseButton from '@/components/V2/BaseButton.vue';

export default {
  name: 'MenuList',

  components: {
    BaseTable,
    BaseButton,
  },

  mixins: [translations],

  props: {
    list: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      idPrefix: 'menus.',
      tableHeaders: [],
    };
  },

  created () {
    this.tableHeaders = [
      {
        label: this.translate('ID'),
        id: 'headermenuid',
      },
      {
        label: this.translate('Name'),
        id: 'headermenuname',
      },
      {
        label: this.translate('Action'),
        id: 'headeraction',
      },
    ];
  },

  computed: {
    paginationConfig () {
      return {
        enabled: false,
      };
    },
  },

  methods: {
    openDeleteMenu (id) {
      this.$emit('deleteMenu', id);
    },
    syncPOS (id) {
      this.$emit('syncPOS', id);
    },
    hardReset (id) {
      this.$emit('hardReset', id);
    },
    onClickingMenu (item) {
      this.$router.push({ name: 'categories list', params: { menuId: item?.id } });
    },
  },
};
</script>

<style scoped>
</style>
